import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FhMenuModel } from '../../../helpers/objects/fh-menu-model';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FhMenuProviderService } from '../../../helpers/providers/fh-menu-provider.service';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Component({
  selector: 'ui-fh-menu-item',
  templateUrl: './fh-menu-item.component.html',
  styleUrls: ['./fh-menu-item.component.scss']
})
export class FhMenuItemComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('dropdownEl') dropdownEl!: ElementRef;

  @Input() item: FhMenuModel = new FhMenuModel();
  @Input() isDropdown: boolean = false;
  @Input() isLastItemDropdown: boolean = false;
  @Output() itemClicked: EventEmitter<FhMenuModel> = new EventEmitter<FhMenuModel>();

  resizeObserver?: ResizeObserver;

  menuExpanded = true;
  menuToggleExpandedSubscription: Subscription = new Subscription();
  icon = this.appConfig.icon;
  constructor(
    @Inject(APP_CONFIG) protected appConfig: EnvironmentModel,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fhMenuProviderService: FhMenuProviderService,
    private eRef: ElementRef
  ) {}

  ngOnInit() {
    this.backgroundEvents();
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
    this.menuToggleExpandedSubscription.unsubscribe();
  }

  @HostListener('document:click', ['$event'])
  clickOut(event: Event) {
    // Se o clique não for dentro do elemento do dropdown,
    // fechamos o menu.
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  backgroundEvents() {
    this.menuToggleExpandedSubscription = this.fhMenuProviderService.menuToggleExpanded.subscribe({
      next: () => {
        if (!this.fhMenuProviderService.isMenuExpanded) {
          this.closeDropdown();
        }

        this.item.expanded = this.fhMenuProviderService.isMenuExpanded && this.item.level == 0;
      }
    });
    if (this.item.childs) {
      this.item.childs.forEach((item) => {
        if (item.childs) {
          item.parentItem = this.item;
        }
      });
    }
  }
  openDropdown() {
    this.item.dropdownOpen = true;

    if (!this.item.expanded) {
      setTimeout(() => {
        this.resizeObserver = new ResizeObserver(() => {
          if (!this.item.expanded && this.item.dropdownOpen) {
            this.adjustDropdownPosition();
          }
        });

        this.resizeObserver.observe(this.dropdownEl.nativeElement);
      });
    }
  }
  closeDropdown() {
    this.resizeObserver?.disconnect();
    this.item.dropdownOpen = false;
  }
  private adjustDropdownPosition() {
    if (!this.dropdownEl) return;

    const dropdown: HTMLElement = this.dropdownEl.nativeElement;
    const rect = dropdown.getBoundingClientRect();
    const bottomSpace = window.innerHeight - rect.bottom;

    if (bottomSpace < 0) {
      const subir = Math.abs(bottomSpace) + 10;
      const atualTop = parseInt(getComputedStyle(dropdown).top || '0', 10);
      dropdown.style.top = atualTop - subir + 'px';
    }
  }

  isMenuExpanded() {
    if (this.item.level == 0) {
      this.menuExpanded = this.fhMenuProviderService.isMenuExpanded;
      return this.menuExpanded;
    } else {
      return true;
    }
  }
  navigate(): void {
    sessionStorage.removeItem('adhesion-company-data');
    if (this.item.childs && this.item.childs.length > 0) {
      if (this.item.dropdownOpen) {
        this.closeDropdown();
        return;
      }

      if (this.item.level == 0) {
        this.fhMenuProviderService.dropdownToggleChanged.emit(true);
      }

      this.openDropdown();
    } else if (this.item.link) {
      this.itemClicked.emit(this.item);

      this.fhMenuProviderService.activeToggleChanged.emit(this.item);
      this.item.active = true;
      if (this.item.state) {
        this.router.navigate(this.item.link.split('/'), {
          state: this.item.state
        });
      } else if (this.item.external) {
        window.open(this.item.link, '_blank');
      } else if (this.item.outlet) {
        const json = JSON.parse('[{"outlets":{"' + this.item.outlet + '":' + JSON.stringify(this.item.link.split('/')) + '}}]');

        this.router.navigate(json, { queryParams: this.item?.queryParams });
      } else if (this.item.relativeRoute) {
        this.router.navigate(this.item.link.split('/'), {
          queryParams: this.item?.queryParams,
          relativeTo: this.activatedRoute
        });
      } else {
        this.router.navigate(this.item.link.split('/'), {
          queryParams: this.item?.queryParams
        });
      }
    } else {
      this.fhMenuProviderService.activeToggleChanged.emit(this.item);
      this.item.active = true;
      this.fhMenuProviderService.itemClicked.emit(this.item);
    }
  }

  isDropdownItem() {
    if (this.isDropdown && !this.isLastItemDropdown) {
      return true;
    } else if (!this.isDropdown) {
      return true;
    }

    return false;
  }
}
